import { render, staticRenderFns } from "./DashboardItem.vue?vue&type=template&id=6ae2b9e8&scoped=true"
import script from "./DashboardItem.vue?vue&type=script&lang=js"
export * from "./DashboardItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae2b9e8",
  null
  
)

export default component.exports